import React, {useContext} from 'react'
import renderLoading from 'views/MainPage/functions/renderPagingLoading'
import MainContext from 'views/MainPage/MainContext'
import {Queries} from 'views/Shared/enums/Queries'
import {useMenuHandler} from 'views/Shared/handlers/useMenuHandler'
import WorkspaceInsights from '../Insights/WorkspaceInsights'
import WorkspaceActivityCalendar from './WorkspaceActivityCalendar'
import UnderDevelopment from "../../Shared/components/UnderDevelopment";

// ItemKeys.NOTIFICATIONS đã bỏ - xem comment ở HOME_SUB_ITEMS (Workspace.js). WorkspaceNotifications
// không còn được import/route tới từ đây nhưng file component vẫn giữ nguyên, không xoá.
const ItemKeys = Object.freeze({
    SUMMARY_BOARD: 'summary-board',
    ACTIVITY_CALENDAR: 'activity-calendar',
    RECENT_ACTIVITIES: 'recent-activities',
})
const routeEntities = [
    {
        key: ItemKeys.SUMMARY_BOARD,
        component: WorkspaceInsights,
    },
    {
        key: ItemKeys.ACTIVITY_CALENDAR,
        component: WorkspaceActivityCalendar,
    },
    {
        key: ItemKeys.RECENT_ACTIVITIES,
        component: UnderDevelopment,
    },
].map(({key, ...rest}) => ({
    key,
    path: key,
    ...rest,
}))

const WorkspaceHome = () => {
    const {isLoading} = useContext(MainContext)

    const {activeKey, Component, onMenuSelect} = useMenuHandler({
        routes: routeEntities,
        actionName: Queries.REL,
    })

    return (
        <div className="px-3 md:px-6">
            {!!isLoading ? renderLoading() : <Component/>}
        </div>
    )
}

export default WorkspaceHome
